<mat-toolbar class="mat-elevation-z1">
  <!--color="primary"-->
  <button mat-icon-button id="menu" (click)="navService.toggleNav()">
    <!--(click)="navService.openNav()"-->
    <mat-icon>menu</mat-icon>
  </button>
  <!--<span>Dynamic Expanding Nav Drawer Example</span>-->
  <div class="admin-head">
    <div class="orgname">
      {{Corp.OrgName}}
    </div>


    <div *ngIf="showBranchSelection" class="branch-selector">
      <mat-select [disabled]="!isAdminUser" #units placeholder="Branch"
                  (opened)="units.placeholder=''"
                  (closed)="units.value === undefined?units.placeholder='Branch':''"
                  (selectionChange)="changeBranch($event.value)"
                  [(ngModel)]="selectedUnit" >
        <mat-option *ngFor="let u of Corp.OrgUnits" [value]="u">
          {{u.UnitName}}
        </mat-option>
      </mat-select>
    </div>
    <div class="loggedin-user">

      <div>{{LoggedInUser.FirstName}} {{LoggedInUser.LastName}}</div>
      <a class="form-icons" title="Logout" href="../Account/Logout">
        <mat-icon class="form-icons">logout</mat-icon>
      </a>
    </div>
  </div>
</mat-toolbar>
